import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseModalDirective } from '@app/components/modals/base-modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IGetCoverageDetails, IEndCoverageDetails } from '../../../models/endCoverage.model';
import { ServiceConfigService } from '@app/services/service-config.service';
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';
@Component({
    templateUrl: './end-coverage-summary-modal.component.html',
    styleUrls: ['./end-coverage-summary-modal.component.scss'],
    standalone: false
})

export class EndCoverageSummaryModalComponent extends BaseModalDirective implements OnInit {
  constructor(
    @Inject(BsModalRef) protected modalRef: BsModalRef,
    @Inject(FormBuilder) protected builder: FormBuilder, private serverConfig: ServiceConfigService, private analytics: GoogleAnalyticsService) {
    super(modalRef, builder);
  }
  @Input() entityDetails: IGetCoverageDetails[] = [];
  @Input() appNum: number;
  @Input() endCvgOrMoveOutSw: string;
  @Input() moveSomeoneOutSw: string;
  rmcVolTermChangeSwitch: boolean = false;

  ngOnInit(): void {
    this.rmcVolTermChangeSwitch = this.serverConfig.getServerConfig()?.rmcVolTermChangeSwitch;
    if (this.rmcVolTermChangeSwitch) {
      this.analytics.trackEndCoverageEvent('rmc_endcoverage_modalpopup_shown');
    }
  }

    // Only members eligible for voluntary termination are shown/submitted when the switch is on
  get filteredEntityDetails(): IGetCoverageDetails[] {
    if (!this.entityDetails) {
      return [];
    }
    if (!this.rmcVolTermChangeSwitch) {
      return this.entityDetails;
    }
    return this.entityDetails.filter((entity: IGetCoverageDetails) => entity?.applyForCvrgSw === 'Y' && entity?.volTermSw === 'Y');
  }

  buildRequestQuery(): IEndCoverageDetails[] {
    const data: IEndCoverageDetails[] = []
    if (this.entityDetails) {
      let appNumber : any;   
      appNumber = sessionStorage.getItem('appNum'),
      this.entityDetails.forEach((entity: IGetCoverageDetails) => {
        let item: IEndCoverageDetails;
        if (this.rmcVolTermChangeSwitch) {
          const isEligibleForVolTerm = entity?.applyForCvrgSw === 'Y' && entity?.volTermSw === 'Y';
          item = {
            'appNum': appNumber,
            'indvId': entity.indvNum,
            'caseNum': entity.caseNum,
            'srcAppInd': "C",
            deleteFlag: isEligibleForVolTerm
          };
        } else {
          item = {
            'appNum': appNumber,
            'indvId': entity.indvNum,
            'caseNum': entity.caseNum,
            'srcAppInd': "C"
          };
        }
        data.push(item);
      })
    }
    return data;
  }

  onConfirm(): void {
    const data = this.buildRequestQuery();    
    if (data) {
      const payload: any = { data };
      if (this.endCvgOrMoveOutSw) {
        payload['endCvgOrMoveOutSw'] = this.endCvgOrMoveOutSw;
        payload['moveSomeoneOutSw'] = this.moveSomeoneOutSw;
      }
      if (this.rmcVolTermChangeSwitch) {
        this.analytics.trackEndCoverageEvent('rmc_endcoverage_modalpopup_confirmed');
      }
      this.hide(payload);
      super.onConfirm();
    }
  }

  onCancel(): void {
    this.hide('');
    this.entityDetails = null;
  }

}
